<template>
  <div>
    <div class="d-start-start materials-document mb-3 mt-4">
        <div class="picture">
            <p class="icon"><i class="icon-cedaohang-kehuguanli iconfont"></i></p>
            <!--提示文字-->
            <div class="picture-text">
                <h2 class="mb-2">营业执照</h2>
                <p>请上传营业执照 <span class="text-danger">(必填)</span></p>
                <p class="mb-2">需清晰、完整、在有效期内</p>
                <upload-image @fileChange="(imgs)=>{applyForm.certpic = imgs[0];}" :existImgs="applyForm.certpic" :maxLength="1" :editMode="showEditModel" :certMode="true" />
            </div>
        </div>
        <div class="picture" v-if="storeInfo.type==2">
            <p class="icon"><i class="icon-cedaohang-kehuguanli iconfont"></i></p>
            <!--提示文字-->
            <div class="picture-text">
                <h2 class="mb-2">旅行社许可证</h2>
                <p>请上传旅行社许可证 (可选)</p>
                <p class="mb-2">需清晰、完整、在有效期内</p>
                <upload-image @fileChange="(imgs)=>{applyForm.licence = imgs[0];}" :existImgs="applyForm.licence" :maxLength="1" :editMode="showEditModel" :certMode="true" />
            </div>
        </div>
        <template v-if="storeInfo.type==3">
            <div class="picture" >
                <p class="icon"><i class="icon-cedaohang-kehuguanli iconfont"></i></p>
                <!--提示文字-->
                <div class="picture-text">
                    <h2 class="mb-2">消防验收合格证</h2>
                    <p>请上传消防验收合格证 (可选)</p>
                    <p class="mb-2">需清晰、完整、在有效期内</p>
                    <upload-image @fileChange="(imgs)=>{applyForm.certfire = imgs[0];}" :existImgs="applyForm.certfire" :maxLength="1" :editMode="showEditModel" :certMode="true" />
                </div>
            </div>
            <div class="picture">
                <p class="icon"><i class="icon-cedaohang-kehuguanli iconfont"></i></p>
                <!--提示文字-->
                <div class="picture-text">
                    <h2 class="mb-2">卫生许可证</h2>
                    <p>请上传卫生许可证 (可选)</p>
                    <p class="mb-2">需清晰、完整、在有效期内</p>
                    <upload-image @fileChange="(imgs)=>{applyForm.certheal = imgs[0];}" :existImgs="applyForm.certheal" :maxLength="1" :editMode="showEditModel" :certMode="true" />
                </div>
            </div>
                    <div class="picture">
                <p class="icon"><i class="icon-cedaohang-kehuguanli iconfont"></i></p>
                <!--提示文字-->
                <div class="picture-text">
                    <h2 class="mb-2">特种行业许可证</h2>
                    <p>请上传特种行业许可证 (可选)</p>
                    <p class="mb-2">需清晰、完整、在有效期内</p>
                    <upload-image @fileChange="(imgs)=>{applyForm.certspec = imgs[0];}" :existImgs="applyForm.certspec" :maxLength="1" :editMode="showEditModel" :certMode="true" />
                </div>
            </div>
        </template>
    </div>
  </div>
</template>

<script>
import {mapGetters, } from 'vuex'
export default {
  name: 'MaterialsDocument',
  components: {},
  props: {
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
        showEditModel:true,        //编辑认证信息模式
        applyForm: {
            certpic: '',
            licence: '',                //经营许可证
            certfire: '',               //消防验收合格证
            certheal: '',               //卫生许可证
            certspec: '',               //特种行业许可证
        },
    };
  },
  computed: {
    ...mapGetters(['storeInfo','isGroup','userInfo'])
  },
  watch: {
    formData: {
      handler(newVal, oldVal) {
        // 合并对象只合并第一个存在的key
        this.applyForm = this.$_Object.getMergedObj(this.applyForm, newVal)
      },
      deep: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    async handleSubmit() {
        let formData = {...this.applyForm}
        // 校验营业执照是否上传
        if (!formData.certpic) {
            this.$message.error('请上传营业执照')
            throw new Error('缺少营业执照')
        }
        return formData;

    }
  }
};
</script>

<style lang="scss" scoped>
    .picture{
        border: 1px solid #eff4fa;
        background-color: #f9fcfe;
        width: 27.8%;
        padding: 2%;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 2%;
        margin-right: 2%;
    }
    .picture:nth-child(3n){
        margin-right: 0;
    }
    .materials-document{
        display: flex;
        flex-wrap: wrap;
    }
    .picture .icon{
        width: 40px;
        height: 40px;
        background-color: #1a93fe;
        color: #fff;
        text-align: center;
        line-height: 40px;
        border-radius: 4px;
    }
    .picture-text{
        margin-left: 10px;
        p{
            color: #999;
        }
    }
</style>
